import { MainNav, MobileNav } from "@/components/core/nav";
import { ThemeToggle } from "@/components/core/theme-toggle";
import { Link } from "@/components/ui/link";
import { cn } from "@/lib/utils";
import ClipboardPenIcon from "lucide-solid/icons/clipboard-pen";
import { type ComponentProps, splitProps } from "solid-js";

export interface HeaderProps extends ComponentProps<"header"> {}

export default function Header(props: HeaderProps) {
  const [local, rest] = splitProps(props, ["class"]);

  return (
    <header
      class={cn(
        "fixed top-0 z-50 w-full border-grid border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background",
        local.class,
      )}
      {...rest}
    >
      <div class="container-wrapper">
        <div class="container flex min-h-16 max-w-none items-center justify-between gap-x-4">
          <MainNav />
          <MobileNav />
          <ThemeToggle />
        </div>
      </div>
    </header>
  );
}
